export enum PermissionsTypes {
  SwitchOnCamera = 'switchOnCamera',
  SwitchOnMic = 'switchOnMic',
  ShareScreen = 'shareScreen',
}

export enum PermissionsValue {
  Everyone = 'EVERYONE',
  AfterApprove = 'AFTER_APPROVE',
  AdminsAndOwner = 'ADMINS_AND_OWNER',
}

export enum PermissionsPersonalizedValue {
  Always = 'ALWAYS',
  Never = 'NEVER',
  AfterApprove = 'AFTER_APPROVE',
}

export enum PermissionRequestAccess {
  Camera = 'CAMERA',
  Mic = 'MIC',
  ScreenSharing = 'SCREEN_SHARING',
}

export enum PermissionsRequestStatuses {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
}

export interface ICallPermissions {
  [PermissionsTypes.ShareScreen]?: PermissionsValue;
  [PermissionsTypes.SwitchOnCamera]?: PermissionsValue;
  [PermissionsTypes.SwitchOnMic]?: PermissionsValue;
}

export interface ICallPersonalizedPermissions {
  [PermissionsTypes.ShareScreen]?: PermissionsPersonalizedValue;
  [PermissionsTypes.SwitchOnCamera]?: PermissionsPersonalizedValue;
  [PermissionsTypes.SwitchOnMic]?: PermissionsPersonalizedValue;
}

export interface ICallCustomPermissions {
  personalizedCallPermissions: ICallPersonalizedPermissions;
  userId: string;
}

export interface ICallPermissionsSettings {
  default: ICallPermissions;
  defaultPersonalized: ICallPersonalizedPermissions;
  personalized?: ICallPersonalizedPermissions;
  usersWithCustomPermissions?: ICallCustomPermissions[];
}

export interface ICallPermissionsChanged {
  changedPermissions: ICallPersonalizedPermissions;
  default: ICallPermissions;
  defaultPersonalized: ICallPersonalizedPermissions;
}

export interface ICallUserPermissionsChanged extends ICallCustomPermissions {
  purged: boolean;
}

export interface ICallUserPermissionsRequestChanged extends ICallCustomPermissions {
  status: PermissionsRequestStatuses;
}

export interface ICallUserPermissionRequestCreated {
  userId: string;
  access: PermissionRequestAccess;
}

export interface ICallPermissionRequests {
  [PermissionsTypes.SwitchOnCamera]: string[];
  [PermissionsTypes.SwitchOnMic]: string[];
  [PermissionsTypes.ShareScreen]: string[];
}

export enum CallMemberRole {
  Superuser = 'SUPERUSER',
  Member = 'MEMBER',
  Guest = 'GUEST',
}

export interface ICallParticipantIdToRole {
  userId: string;
  role: CallMemberRole;
}
